import { Link } from 'react-router-dom';
import type { HiringGap } from '../../services/api/capacity';
import { formatFte } from '../../utils/format';

interface HiringGapsSummaryProps {
  gaps: HiringGap[];
}

function monthLabel(month: string): string {
  const [year, m] = month.split('-');
  const names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${names[parseInt(m!, 10) - 1]} ${year}`;
}

export default function HiringGapsSummary({ gaps }: HiringGapsSummaryProps) {
  if (gaps.length === 0) return null;

  return (
    <div className="mt-6 bg-white rounded-lg border border-gray-200 p-4">
      <h3 className="text-sm font-semibold text-gray-900 mb-3">Hiring Gaps</h3>
      <div className="overflow-auto">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Month</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Role</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase">Needed</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase">Assigned</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase">Gap</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Projects</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {gaps.map((gap, i) => (
              <tr key={i} className="hover:bg-gray-50">
                <td className="px-3 py-2 text-gray-700">{monthLabel(gap.month)}</td>
                <td className="px-3 py-2 font-medium text-gray-900">
                  {gap.roleCode ? `${gap.roleCode} — ${gap.roleName}` : gap.roleName}
                </td>
                <td className="px-3 py-2 text-right text-gray-700">{formatFte(gap.totalNeeded)}</td>
                <td className="px-3 py-2 text-right text-gray-700">{formatFte(gap.totalAssigned)}</td>
                <td className="px-3 py-2 text-right font-semibold text-red-600">{formatFte(gap.gap)}</td>
                <td className="px-3 py-2 text-gray-500 text-xs">
                  {gap.projects.map((p, i) => (
                    <span key={p.projectId}>
                      {i > 0 && ', '}
                      <Link to={`/projects/${p.projectId}`} className="text-primary-600 hover:underline">{p.projectName}</Link>
                      {' '}({formatFte(p.needed)})
                    </span>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
